const themesData = [
	/* INDUSTRIBRANCHEN - TEMA 1 */
	{
		isActive: true,
		id: 'theme-1-1',
		branchId: 'branch-1',
		introVideoId: {
			da: 'UeQx58eK728',
			en: 'wsZvcQYYzCY'
		},
		title: {
			da: 'Tema 1',
			en: 'Theme 1'
		},
		subtitle: {
			da: 'Villighed til at hjælpe',
			en: 'Willingness to help'
		},
		intro: {
			da: `Dette tema handler om villighed til at hjælpe. Hvordan kan I støtte hinanden bedre i hverdagen, og hvad betyder det for samarbejdet, når I gør det?
				<br /><br />Se filmen herunder for at høre mere om temaet.`,
			en: `This theme is about a willingness to help. How can you support each other better in everyday life, and what does this mean for your collaboration?
				<br /><br />Watch the video below to find out more about this theme.`
		},
		gameSteps: require('data/game-steps/theme-1-1-game-steps').gameSteps,
		resultSteps: [
			{
				id: 'result-1',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-1-1-survey',
				questionId: 'theme-1-1-survey-q1',
				text: {
					da: `Hvad oplever du som de største udfordringer i forhold til hjælpsomhed på din arbejdsplads?`,
					en: `What do you see as the biggest challenges when it comes to willingness to help in your place of work?`
				},
			},
			{
				id: 'result-2',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-1-1-survey',
				questionId: 'theme-1-1-survey-q2',
				text: {
					da: `Hvad er vigtigst for dig i forhold til hjælpsomhed på din arbejdsplads?`,
					en: `What is most important to you when it comes to helping each other in your place of work?`
				},
			},
		],
		microActions: [
			{
				id: 1,
				title: {
					da: `Ugens hjælp`,
					en: `Help Of The Week`
				},
				shortText: {
					da: `Bed en kollega fortælle en kort historie om at have hjulpet med eller fået hjælp til en konkret opgave.`,
					en: `Ask a colleague to tell a short story about having or being helped with a specific task.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At sætte fokus på konkrete eksempler på hjælpsomhed og gøre det mere synligt, hvordan vi støtter hinanden i hverdagen.
						<br /><br /><b>Hvad</b>
						<br />Lederen udpeger én kollega hver uge til at dele en kort fortælling om en situation, hvor en kollega hjalp vedkommende eller en anden med at løse en opgave. Det kan være alt fra at tage en ekstra vagt, hjælpe med en teknisk udfordring eller give sparring i en presset situation.
						<br />Fortællingen skal være kort – maks. 2 minutter – og have fokus på, hvad hjælpen betød.
						<br /><br /><b>Hvornår</b>
						<br />Fortællingen deles fast én gang om ugen – fx som fast punkt på teammødet om mandagen eller fredagens tavlemøde.`,
					en: `<b>Purpose</b>
						<br />To focus on specific instances of willingness to help, and to make it more obvious how we help each other on a day to day basis. 
						<br /><br /><b>What</b>
						<br />The manager appoints a colleague each week to share a short story about a situation in which a colleague helped them or someone else with a task. Maybe they covered a shift, assisted with a technical challenge, or gave good feedback in a tight spot. 
						<br />Keep it short - no more than 2 minutes - and fokus on, what the help meant. 
						<br /><br /><b>When</b>
						<br />Share a story at a specific time once a week - maybe during the team meeting Monday mornings.`
				}
			},
			{
				id: 2,
				title: {
					da: `Giv-en-hånd-runde`,
					en: 'Shake Hands'
				},
				shortText: {
					da: `Start hver vagt med en kort checkin hvor I spørger: "Er der nogen der har brug for en ekstra hånd i dag?"`,
					en: `Start every shift with a short check in where you ask: "Does anyone need an extra hand today?"`
				},
				text: {
					da: `<b>Formål</b>
						<br />At gøre det nemt at bede om hjælp – og skabe plads til, at vi kan støtte hinanden allerede fra dagens start.
						<br /><br /><b>Hvad</b>
						<br />Når arbejdsdagen eller vagten starter, tager I en hurtig runde i teamet:
						<br />“Er der nogen, der har brug for en ekstra hånd i dag?”
						<br />Det kan være en opgave, der er presset på tid, noget man ikke når selv, eller noget man gerne vil have sparring på.
						<br />Andre i teamet kan byde ind, hvis de har overskud og mulighed.
						<br /><br /><b>Hvornår</b>
						<br />Gennemføres som en del af dagens eller vagtens opstart – fx ved morgenmøde, briefing, vagtskifte eller når teamet samles.`
					,
					en: `<b>Purpose</b>
						<br />To make asking for help easy. And to create a space where we can support each other. 
						<br /><br /><b>What</b>
						<br />When the shift starts, do a quick round with the team. 
						<br />"Does anyone need an extra hand today?"
						<br />Maybe something has to be done extra quickly, maybe you don't have time for something yourself, or maybe you just need a second opinion. All team members can join in, if they have the band with for it. 
						<br /><br /><b>When</b>
						<br />Do it when the day or shift begins - during a morning meting, a daily stand up, or shift change.`
				}
			},
			{
				id: 3,
				title: {
					da: `"Tak for hjælpen"-runde`,
					en: `"Thanks For Helping"`
				},
				shortText: {
					da: `Ved fyraften siger man tak til en person, som har hjulpet én i løbet af dagen.`,
					en: `At the end of the shift, you thank a person, who have helped you during the day.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At styrke kulturen for anerkendelse og gøre det til en vane at sige tak for den hjælp, vi giver og modtager i løbet af dagen.
						<br /><br /><b>Hvad</b>
						<br />Ved arbejdsdagens afslutning (eller slutningen på en vagt), tager teamet en hurtig runde, hvor hver person nævner én kollega, de gerne vil sige tak til for hjælp i løbet af dagen. Det kan være alt fra praktisk hjælp til en god samtale.
						<br />Det tager kun få sekunder pr. person – men har stor betydning.
						<br /><br /><b>Hvornår</b>
						<br />Bruges fast ved dagens eller vagtens afslutning – fx som sidste punkt på tavlemødet eller som afrunding i teamet inden fyraften.`,
					en: `<b>Purpose</b>
						<br />To strengthen a culture of acknoledgement and to make saying "thank you" a habit. 
						<br /><br /><b>What</b>
						<br />When the day or shift ends, do a quick round in the team and have each person mention a colleague whom they want to thank for having helped them. Maybe for help with a task, for a good talk, or something. It only takes a few seconds per person, but can have great impact. 
						<br /><br /><b>When</b>
						<br />Do it regularly at the end of the day or shift.`
				}
			}
		]
	},


	/* INDUSTRIBRANCHEN - TEMA 2 */
	{
		isActive: true,
		id: 'theme-1-2',
		branchId: 'branch-1',
		introVideoId: {
			da: 'f3_zUXArxCk',
			en: 'qTKZGmNlicc'
		},
		title: {
			da: 'Tema 2',
			en: 'Theme 2'
		},
		subtitle: {
			da: 'Forskelligheder i fællesskabet',
			en: 'Differences within the workplace'
		},
		intro: {
			da: `Dette tema handler om diversitet og inklusion. Hvordan sikrer I, at alle føler sig som en del af fællesskabet, og at forskellige perspektiver bliver værdsat?
				<br /><br />Se filmen herunder for at høre mere om temaet.`,
			en: `This theme is about diversity and inclusion. How do you ensure that everyone feels part of the team and that different perspectives are valued?
				<br /><br />Watch the video below to find out more about this theme.`
		},
		gameSteps: require('data/game-steps/theme-1-2-game-steps').gameSteps,
		resultSteps: [
			{
				id: 'result-1',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-1-2-survey',
				questionId: 'theme-1-2-survey-q1',
				text: {
					da: `Hvad oplever du som de største udfordringer, når det handler om at alle bliver set, hørt og respekteret?`,
					en: `What do you see as the biggest obstacles when it comes to being seen, heard, and respected?`
				},
			},
			{
				id: 'result-2',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-1-2-survey',
				questionId: 'theme-1-2-survey-q2',
				text: {
					da: `Hvad er vigtigst for dig for at føle dig set, hørt og respekteret på din arbejdsplads?`,
					en: `What is most important for you in order to feel seen, heard, and valued at your place of work?`
				},
			}
		],
		microActions: [
			{
				id: 1,
				title: {
					da: `Hej til alle`,
					en: `Hello To Everyone`
				},
				shortText: {
					da: `Hils på alle, når du møder ind. Sørg for, at ingen bliver overset.`,
					en: `Say hello to everyone when you start your day. Make sure not to miss anyone.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At få alle til at føle sig set og velkommen. Det skaber en god stemning fra start.
						<br /><br /><b>Hvad</b>
						<br />Sig hej til alle, når du møder ind. Brug navn hvis du kender det. Smil eller nik – også til dem du ikke arbejder tæt med. I kan gøre det til en fælles aftale i teamet.
						<br /><br /><b>Hvornår</b>
						<br />Hver dag – både når man møder og i løbet af dagen.`,
					en: `<b>Purpose</b>
						<br />To make everybody feel seen and welcome. It creates a good mood right away. 
						<br /><br /><b>What</b>
						<br />Say hello to everyone when you start the day. Use their name, if you know it. Smile or nod - also to the people you don't work with on a daily basis. Have everyone in the team agree to do it. 
						<br /><br /><b>When</b>
						<br />Every day. When you start your shift, but also during the day.`
				}
			},
			{
				id: 2,
				title: {
					da: `Få alle med`,
					en: `Bring Everyone In`
				},
				shortText: {
					da: `Brug en 1-2-alle-struktur til at få alle til at byde ind til møder. Alle tænker 1 minut, derefter deles der med en sidemakker og til sidst er der fælles dialog.`,
					en: `Use 1-2-all structure to have everybody join in during meetings. You should all think for 1 minute, share with the person next to you, and then have a shared dialogue.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At sikre at alle kommer til orde – også dem der ikke siger noget først.
						<br /><br /><b>Hvad</b>
						<br />Hvis I skal tale om et emne på et møde, så kan I bruge følgende struktur til det: 1) Tænk selv i 1 minut, 2) Tal med en kollega i 2- 3 minutter, 3) Del i fællesskab. Det gør det nemmere at sige noget, når man har haft tid til at tænke og vende det med en anden inden.
						<br /><br /><b>Hvornår</b>
						<br />Når I holder møder eller skal træffe beslutninger.`,
					en: `<b>Purpose</b>
						<br />To ensure that everybody gets a say - including those who aren't the first to talk. 
						<br /><br /><b>What</b>
						<br />When discussing something during a meeting, usee the following structure: 
						<br />1) Think about it for 1 minute. 
						<br />2) Talk to a colleague about it for 2-3 minutes. 
						<br />3) Share with the group. 
						<br />Having time to think and discuss it with another person makes it easier to say something to the entire group. 
						<br /><br /><b>When</b>
						<br />During meetings or when making decisions.`
				}
			},
			{
				id: 3,
				title: {
					da: `Små fortælle-runder`,
					en: `Small Stories`
				},
				shortText: {
					da: `Lav en runde med overskriften: "Fortæl om noget, du godt kan lide at lave udenfor arbejdet." Så lærer I hinanden at kende som mennesker.`,
					en: `Tell each other short stories with the headline "Something I like to do when I'm not at work." That way you'll get to know each other as people and not just colleagues.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At lære hinanden bedre at kende og få et bedre sammenhold.
						<br /><br /><b>Hvad</b>
						<br />Beslut jer for hvornår I kan lave nogle små runder med spørgsmål, hvor I lærer hinanden bedre at kende. I kan eventuelt lave en række spørgsmål på nogle kort, som man kan trække ét af. Det kan være spørgsmål som 'Hvad gør dig i godt humør?' eller 'Hvad kan du lide at lave udenfor arbejdet?'. Sæt eventuelt en tidsramme på det på 5-10 minutter, så I blot taler kort.
						<br /><br /><b>Hvornår</b>
						<br />Af og til på møder eller i pausen, når der er lidt luft. Gør det eventuelt til en fast del af frokostpausen, at man spørger mindst én kollega om noget, der ikke handler om arbejdet.`,
					en: `<b>Purpose</b>
						<br />To get to know each other and to create a sense of being a group. 
						<br /><br /><b>What</b>
						<br />Decide when to do a short story session to get to know each other. Maybe you can make a handful of cards with questions, and you draw one each. Good questions could be: ""What makes you happy?"" or ""What do you like to do when you're not at work?"" Schedule 5-10 minutes so you keep the stories short. 
						<br /><br /><b>When</b>
						<br />Every now and then during meetings or a break. Maybe make it a tradition during lunch to ask at least one colleague about something not work related. "`
				}
			},
		]
	},


	/* INDUSTRIBRANCHEN - TEMA 3 */
	{
		isActive: true,
		id: 'theme-1-3',
		branchId: 'branch-1',
		introVideoId: {
			da: '0-xxB4-a3lQ',
			en: '1eDY0p3c3yQ'
		},
		title: {
			da: 'Tema 3',
			en: 'Theme 3'
		},
		subtitle: {
			da: 'Når der sker fejl',
			en: 'When mistakes happen'
		},
		intro: {
			da: `Dette tema handler om holdning til risiko og fejl. Hvordan håndterer I fejl, og hvordan kan I skabe et miljø, hvor fejl bliver noget I aktivt forholder jer til og lærer af?
				<br /><br />Se filmen herunder for at høre mere om temaet.`,
			en: `This theme focuses on attitudes towards risk and mistakes. How do you cope with mistakes, and how can you create an environment where mistakes are something you actively address and learn from?
				<br /><br />Watch the video below to find out more about this theme.`
		},
		gameSteps: require('data/game-steps/theme-1-3-game-steps').gameSteps,
		resultSteps: [
			{
				id: 'result-1',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-1-3-survey',
				questionId: 'theme-1-3-survey-q1',
				text: {
					da: `Hvad er de største udfordringer på din arbejdsplads, når der sker fejl?`,
					en: `What are the biggest challenges in your place of work when mistakes happen?`
				},
			},
			{
				id: 'result-2',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-1-3-survey',
				questionId: 'theme-1-3-survey-q2',
				text: {
					da: `Hvad er vigtigst for dig, når der sker fejl på din arbejdsplads?`,
					en: `What is most important for you when mistakes happen in your place of work?`
				},
			}
		],
		microActions: [
			{
				id: 1,
				title: {
					da: `Del en læring`,
					en: `Share What You've Learned`
				},
				shortText: {
					da: `Mindst én gang om ugen deler alle noget, de har lært for nylig, med nogle kollegaer.`,
					en: `At least once a week, everybody shares something they've learned recently.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At gøre det normalt at tale om fejl og hvad vi kan lære af dem. Det hjælper os med at blive klogere og støtte hinanden.
						<br /><br /><b>Hvad</b>
						<br />Alle deler én gang om ugen noget der gik galt eller noget der ikke gik, som det skulle og hvad vedkommende lærte af det. Tal sammen om det og hjælp hinanden til at få gjort læringen tydelig. Det kan deles, når I er samlet som kollegaer alle sammen eller i små grupper.
						<br /><br /><b>Hvornår</b>
						<br />Én gang om ugen – fx på et tavlemøde eller i frokostpausen.`,
					en: `<b>Purpose</b>
						<br />To normalise talking about mistakes and what we can learn from them. It helps os get smarter and to support each other. 
						<br /><br /><b>What</b>
						<br />Once a week everybody shares a short story about something that failed or didn't go as planned and what they've learned from it. Talk about it and help each other to learn from it. Share it in a meeting, or in a small group. 
						<br /><br /><b>When</b>
						<br />Once a week - maybe during a daily stand up or during lunch.`
				}
			},
			{
				id: 2,
				title: {
					da: `Læringstavlen`,
					en: `The Board Of Learning`
				},
				shortText: {
					da: `Lav en opslagstavle, hvor medarbejdere kan hænge små kort op med overskriften "Jeg lærte at ..."`,
					en: `Make a pin board where you can post small notes with the headline: "I learned that ..."`
				},
				text: {
					da: `<b>Formål</b>
						<br />At samle små læringer, så I kan lære af hinanden og blive bedre sammen.
						<br /><br /><b>Hvad</b>
						<br />Sæt en opslagstavle op med post-its eller kort, hvor man kan skrive: 'Jeg lærte at…' Det kan være fejl, forbedringer eller små opdagelser. Tavlen kan tømmes eller læses op én gang om ugen. Det kan også gøres digitalt et sted i kommunikere med hinanden.
						<br /><br /><b>Hvornår</b>
						<br />Løbende – og gennemgå eventuelt én gang om ugen eller måneden.`,
					en: `<b>Purpose</b>
						<br />To collect experience so you can learn from each other and get better together. 
						<br /><br /><b>What</b>
						<br />Make a pinboard where you can post notes saying ""I learned that ..."" It can be mistakes, improvements, or small discoveries. Empty the board or read the notes once a week. You can also do it digitally if you have a place for it. 
						<br /><br /><b>When</b>
						<br />On a daily basis - but sum up once a week or once a month.`
				}
			},
			{
				id: 3,
				title: {
					da: `Vend fejlen om`,
					en: `Flip The Mistake`
				},
				shortText: {
					da: `Når der sker en fejl, øver vi os i at spørge: "Hvad kan vi lære af det her?" og "Kan vi gøre noget, så det ikke sker igen?"`,
					en: `When a mistake has been made, we practice asking: "What can we learn from this?" and "what can we do to keep it from happening again?"`
				},
				text: {
					da: `<b>Formål</b>
						<br />At gøre fejl til noget I lærer af, i stedet for at det kan blive noget, man skammer sig over.
						<br /><br /><b>Hvad</b>
						<br />Når der sker en fejl, sørger vi for, at vi tager fat i fejlen samme dag og besvare to spørgsmål: 1) Hvad kan vi lære af det her? 2) Hvad kan vi gøre, så det ikke sker igen? Tal om det roligt og nysgerrigt – ikke for at finde skyld.
						<br /><br /><b>Hvornår</b>
						<br />Samme dag som fejlen sker, men sørg for at der er ro til at tale om fejlen.`,
					en: `<b>Purpose</b>
						<br />To turn mistakes into something you learn from, instead of being something you are ashamed of. 
						<br /><br /><b>What</b>
						<br />When a mistake is made, we make sure to talk about it the very same day and ask two questions: 1) What can we learn from this? 2) What can we do so that it don't happen again?
						<br />Talk about it in a calm and curious manner - it's not about assigning blame. 
						<br /><br /><b>When</b>
						<br />The same day as the mistake has been made. But make sure you have time to talk about it.`
				}
			},
		]
	},

	/* RESTAURATIONSBRANCHEN - TEMA 1 */
	{
		isActive: true,
		id: 'theme-2-1',
		branchId: 'branch-2',
		introVideoId: {
			da: 'UeQx58eK728',
			en: 'wsZvcQYYzCY'
		},
		title: {
			da: 'Tema 1',
			en: 'Theme 1'
		},
		subtitle: {
			da: 'Villighed til at hjælpe',
			en: 'Willingness to help'
		},
		intro: {
			da: `Dette tema handler om villighed til at hjælpe. Hvordan kan I støtte hinanden bedre i hverdagen, og hvad betyder det for samarbejdet, når I gør det?
				<br /><br />Se filmen herunder for at høre mere om temaet.`,
			en: `This theme is about a willingness to help. How can you support each other better in everyday life, and what does this mean for your collaboration?
				<br /><br />Watch the video below to find out more about this theme.`
		},
		gameSteps: require('data/game-steps/theme-2-1-game-steps').gameSteps,
		resultSteps: [
			{
				id: 'result-1',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-2-1-survey',
				questionId: 'theme-2-1-survey-q1',
				text: {
					da: `Hvad oplever du som de største udfordringer i forhold til hjælpsomhed på din arbejdsplads?`,
					en: `What do you see as the biggest challenges when it comes to willingness to help in your place of work?`
				}
			},
			{
				id: 'result-2',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-2-1-survey',
				questionId: 'theme-2-1-survey-q2',
				text: {
					da: `Hvad er vigtigst for dig i forhold til hjælpsomhed på din arbejdsplads?`,
					en: `What is most important to you when it comes to helping each other in your place of work?`
				}
			}
		],
		microActions: [
			{
				id: 1,
				title: {
					da: `Ugens hjælp`,
					en: `Help Of The Week`
				},
				shortText: {
					da: `Bed en kollega fortælle en kort historie om at have hjulpet med eller fået hjælp til en konkret opgave.`,
					en: `Ask a colleague to tell a short story about having or being helped with a specific task.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At sætte fokus på konkrete eksempler på hjælpsomhed og gøre det mere synligt, hvordan vi støtter hinanden i hverdagen.
						<br /><br /><b>Hvad</b>
						<br />Lederen udpeger én kollega hver uge til at dele en kort fortælling om en situation, hvor en kollega hjalp vedkommende eller en anden med at løse en opgave. Det kan være alt fra at tage en ekstra vagt, hjælpe med en teknisk udfordring eller give sparring i en presset situation.
						<br />Fortællingen skal være kort – maks. 2 minutter – og have fokus på, hvad hjælpen betød.
						<br /><br /><b>Hvornår</b>
						<br />Fortællingen deles fast én gang om ugen – fx som fast punkt på teammødet om mandagen eller fredagens tavlemøde.`,
					en: `<b>Purpose</b>
						<br />To focus on specific instances of willingness to help, and to make it more obvious how we help each other on a day to day basis. 
						<br /><br /><b>What</b>
						<br />The manager appoints a colleague each week to share a short story about a situation in which a colleague helped them or someone else with a task. Maybe they covered a shift, assisted with a technical challenge, or gave good feedback in a tight spot. 
						<br />Keep it short - no more than 2 minutes - and fokus on, what the help meant. 
						<br /><br /><b>When</b>
						<br />Share a story at a specific time once a week - maybe during the team meeting Monday mornings.`
				}
			},
			{
				id: 2,
				title: {
					da: `Giv-en-hånd-runde`,
					en: 'Shake Hands'
				},
				shortText: {
					da: `Start hver vagt med en kort checkin hvor I spørger: "Er der nogen der har brug for en ekstra hånd i dag?"`,
					en: `Start every shift with a short check in where you ask: "Does anyone need an extra hand today?"`
				},
				text: {
					da: `<b>Formål</b>
						<br />At gøre det nemt at bede om hjælp – og skabe plads til, at vi kan støtte hinanden allerede fra dagens start.
						<br /><br /><b>Hvad</b>
						<br />Når arbejdsdagen eller vagten starter, tager I en hurtig runde i teamet:
						<br />“Er der nogen, der har brug for en ekstra hånd i dag?”
						<br />Det kan være en opgave, der er presset på tid, noget man ikke når selv, eller noget man gerne vil have sparring på.
						<br />Andre i teamet kan byde ind, hvis de har overskud og mulighed.
						<br /><br /><b>Hvornår</b>
						<br />Gennemføres som en del af dagens eller vagtens opstart – fx ved morgenmøde, briefing, vagtskifte eller når teamet samles.`
					,
					en: `<b>Purpose</b>
						<br />To make asking for help easy. And to create a space where we can support each other. 
						<br /><br /><b>What</b>
						<br />When the shift starts, do a quick round with the team. 
						<br />"Does anyone need an extra hand today?"
						<br />Maybe something has to be done extra quickly, maybe you don't have time for something yourself, or maybe you just need a second opinion. All team members can join in, if they have the band with for it. 
						<br /><br /><b>When</b>
						<br />Do it when the day or shift begins - during a morning meting, a daily stand up, or shift change.`
				}
			},
			{
				id: 3,
				title: {
					da: `"Tak for hjælpen"-runde`,
					en: `"Thanks For Helping"`
				},
				shortText: {
					da: `Ved fyraften siger man tak til en person, som har hjulpet én i løbet af dagen.`,
					en: `At the end of the shift, you thank a person, who have helped you during the day.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At styrke kulturen for anerkendelse og gøre det til en vane at sige tak for den hjælp, vi giver og modtager i løbet af dagen.
						<br /><br /><b>Hvad</b>
						<br />Ved arbejdsdagens afslutning (eller slutningen på en vagt), tager teamet en hurtig runde, hvor hver person nævner én kollega, de gerne vil sige tak til for hjælp i løbet af dagen. Det kan være alt fra praktisk hjælp til en god samtale.
						<br />Det tager kun få sekunder pr. person – men har stor betydning.
						<br /><br /><b>Hvornår</b>
						<br />Bruges fast ved dagens eller vagtens afslutning – fx som sidste punkt på tavlemødet eller som afrunding i teamet inden fyraften.`,
					en: `<b>Purpose</b>
						<br />To strengthen a culture of acknoledgement and to make saying "thank you" a habit. 
						<br /><br /><b>What</b>
						<br />When the day or shift ends, do a quick round in the team and have each person mention a colleague whom they want to thank for having helped them. Maybe for help with a task, for a good talk, or something. It only takes a few seconds per person, but can have great impact. 
						<br /><br /><b>When</b>
						<br />Do it regularly at the end of the day or shift.`
				}
			}
		]
	},

	/* RESTAURATIONSBRANCHEN - TEMA 2 */
	{
		isActive: true,
		id: 'theme-2-2',
		branchId: 'branch-2',
		introVideoId: {
			da: 'f3_zUXArxCk',
			en: 'qTKZGmNlicc'
		},
		title: {
			da: 'Tema 2',
			en: 'Theme 2'
		},
		subtitle: {
			da: 'Forskelligheder i fællesskabet',
			en: 'Differences within the workplace'
		},
		intro: {
			da: `Dette tema handler om diversitet og inklusion. Hvordan sikrer I, at alle føler sig som en del af fællesskabet, og at forskellige perspektiver bliver værdsat?
				<br /><br />Se filmen herunder for at høre mere om temaet.`,
			en: `This theme is about diversity and inclusion. How do you ensure that everyone feels part of the team and that different perspectives are valued?
				<br /><br />Watch the video below to find out more about this theme.`
		},
		gameSteps: require('data/game-steps/theme-2-2-game-steps').gameSteps,
		resultSteps: [
			{
				id: 'result-1',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-2-2-survey',
				questionId: 'theme-2-2-survey-q1',
				text: {
					da: `Hvad oplever du som de største udfordringer, når det handler om at alle bliver set, hørt og respekteret?`,
					en: `What do you see as the biggest obstacles when it comes to being seen, heard, and respected?`
				}
			},
			{
				id: 'result-2',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-2-2-survey',
				questionId: 'theme-2-2-survey-q2',
				text: {
					da: `Hvad er vigtigst for dig for at føle dig set, hørt og respekteret på din arbejdsplads?`,
					en: `What is most important for you in order to feel seen, heard, and valued at your place of work?`
				}
			}
		],
		microActions: [
			{
				id: 1,
				title: {
					da: `Hej til alle`,
					en: `Hello To Everyone`
				},
				shortText: {
					da: `Hils på alle, når du møder ind. Sørg for, at ingen bliver overset.`,
					en: `Say hello to everyone when you start your day. Make sure not to miss anyone.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At få alle til at føle sig set og velkommen. Det skaber en god stemning fra start.
						<br /><br /><b>Hvad</b>
						<br />Sig hej til alle, når du møder ind. Brug navn hvis du kender det. Smil eller nik – også til dem du ikke arbejder tæt med. I kan gøre det til en fælles aftale i teamet.
						<br /><br /><b>Hvornår</b>
						<br />Hver dag – både når man møder og i løbet af dagen.`,
					en: `<b>Purpose</b>
						<br />To make everybody feel seen and welcome. It creates a good mood right away. 
						<br /><br /><b>What</b>
						<br />Say hello to everyone when you start the day. Use their name, if you know it. Smile or nod - also to the people you don't work with on a daily basis. Have everyone in the team agree to do it. 
						<br /><br /><b>When</b>
						<br />Every day. When you start your shift, but also during the day.`
				}
			},
			{
				id: 2,
				title: {
					da: `Få alle med`,
					en: `Bring Everyone In`
				},
				shortText: {
					da: `Brug en 1-2-alle-struktur til at få alle til at byde ind til møder. Alle tænker 1 minut, derefter deles der med en sidemakker og til sidst er der fælles dialog.`,
					en: `Use 1-2-all structure to have everybody join in during meetings. You should all think for 1 minute, share with the person next to you, and then have a shared dialogue.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At sikre at alle kommer til orde – også dem der ikke siger noget først.
						<br /><br /><b>Hvad</b>
						<br />Hvis I skal tale om et emne på et møde, så kan I bruge følgende struktur til det: 1) Tænk selv i 1 minut, 2) Tal med en kollega i 2- 3 minutter, 3) Del i fællesskab. Det gør det nemmere at sige noget, når man har haft tid til at tænke og vende det med en anden inden.
						<br /><br /><b>Hvornår</b>
						<br />Når I holder møder eller skal træffe beslutninger.`,
					en: `<b>Purpose</b>
						<br />To ensure that everybody gets a say - including those who aren't the first to talk. 
						<br /><br /><b>What</b>
						<br />When discussing something during a meeting, usee the following structure: 
						<br />1) Think about it for 1 minute. 
						<br />2) Talk to a colleague about it for 2-3 minutes. 
						<br />3) Share with the group. 
						<br />Having time to think and discuss it with another person makes it easier to say something to the entire group. 
						<br /><br /><b>When</b>
						<br />During meetings or when making decisions.`
				}
			},
			{
				id: 3,
				title: {
					da: `Små fortælle-runder`,
					en: `Small Stories`
				},
				shortText: {
					da: `Lav en runde med overskriften: "Fortæl om noget, du godt kan lide at lave udenfor arbejdet." Så lærer I hinanden at kende som mennesker.`,
					en: `Tell each other short stories with the headline "Something I like to do when I'm not at work." That way you'll get to know each other as people and not just colleagues.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At lære hinanden bedre at kende og få et bedre sammenhold.
						<br /><br /><b>Hvad</b>
						<br />Beslut jer for hvornår I kan lave nogle små runder med spørgsmål, hvor I lærer hinanden bedre at kende. I kan eventuelt lave en række spørgsmål på nogle kort, som man kan trække ét af. Det kan være spørgsmål som 'Hvad gør dig i godt humør?' eller 'Hvad kan du lide at lave udenfor arbejdet?'. Sæt eventuelt en tidsramme på det på 5-10 minutter, så I blot taler kort.
						<br /><br /><b>Hvornår</b>
						<br />Af og til på møder eller i pausen, når der er lidt luft. Gør det eventuelt til en fast del af frokostpausen, at man spørger mindst én kollega om noget, der ikke handler om arbejdet.`,
					en: `<b>Purpose</b>
						<br />To get to know each other and to create a sense of being a group. 
						<br /><br /><b>What</b>
						<br />Decide when to do a short story session to get to know each other. Maybe you can make a handful of cards with questions, and you draw one each. Good questions could be: ""What makes you happy?"" or ""What do you like to do when you're not at work?"" Schedule 5-10 minutes so you keep the stories short. 
						<br /><br /><b>When</b>
						<br />Every now and then during meetings or a break. Maybe make it a tradition during lunch to ask at least one colleague about something not work related. "`
				}
			},
		]
	},

	/* RESTAURATIONSBRANCHEN - TEMA 3 */
	{
		isActive: true,
		id: 'theme-2-3',
		branchId: 'branch-2',
		introVideoId: {
			da: '0-xxB4-a3lQ',
			en: '1eDY0p3c3yQ'
		},
		title: {
			da: 'Tema 3',
			en: 'Theme 3'
		},
		subtitle: {
			da: 'Når der sker fejl',
			en: 'When mistakes happen'
		},
		intro: {
			da: `Dette tema handler om holdning til risiko og fejl. Hvordan håndterer I fejl, og hvordan kan I skabe et miljø, hvor fejl bliver noget I aktivt forholder jer til og lærer af?
				<br /><br />Se filmen herunder for at høre mere om temaet.`,
			en: `This theme focuses on attitudes towards risk and mistakes. How do you cope with mistakes, and how can you create an environment where mistakes are something you actively address and learn from?
				<br /><br />Watch the video below to find out more about this theme.`
		},
		gameSteps: require('data/game-steps/theme-2-3-game-steps').gameSteps,
		resultSteps: [
			{
				id: 'result-1',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-2-3-survey',
				questionId: 'theme-2-3-survey-q1',
				text: {
					da: `Hvad er de største udfordringer på din arbejdsplads, når der sker fejl?`,
					en: `What are the biggest challenges in your place of work when mistakes happen?`
				}
			},
			{
				id: 'result-2',
				type: 'result',
				showProgress: true,
				gameStepId: 'theme-2-3-survey',
				questionId: 'theme-2-3-survey-q2',
				text: {
					da: `Hvad er vigtigst for dig, når der sker fejl på din arbejdsplads?`,
					en: `What is most important for you when mistakes happen in your place of work?`
				}
			},
		],
		microActions: [
			{
				id: 1,
				title: {
					da: `Del en læring`,
					en: `Share What You've Learned`
				},
				shortText: {
					da: `Mindst én gang om ugen deler alle noget, de har lært for nylig, med nogle kollegaer.`,
					en: `At least once a week, everybody shares something they've learned recently.`
				},
				text: {
					da: `<b>Formål</b>
						<br />At gøre det normalt at tale om fejl og hvad vi kan lære af dem. Det hjælper os med at blive klogere og støtte hinanden.
						<br /><br /><b>Hvad</b>
						<br />Alle deler én gang om ugen noget der gik galt eller noget der ikke gik, som det skulle og hvad vedkommende lærte af det. Tal sammen om det og hjælp hinanden til at få gjort læringen tydelig. Det kan deles, når I er samlet som kollegaer alle sammen eller i små grupper.
						<br /><br /><b>Hvornår</b>
						<br />Én gang om ugen – fx på et tavlemøde eller i frokostpausen.`,
					en: `<b>Purpose</b>
						<br />To normalise talking about mistakes and what we can learn from them. It helps os get smarter and to support each other. 
						<br /><br /><b>What</b>
						<br />Once a week everybody shares a short story about something that failed or didn't go as planned and what they've learned from it. Talk about it and help each other to learn from it. Share it in a meeting, or in a small group. 
						<br /><br /><b>When</b>
						<br />Once a week - maybe during a daily stand up or during lunch.`
				}
			},
			{
				id: 2,
				title: {
					da: `Læringstavlen`,
					en: `The Board Of Learning`
				},
				shortText: {
					da: `Lav en opslagstavle, hvor medarbejdere kan hænge små kort op med overskriften "Jeg lærte at ..."`,
					en: `Make a pin board where you can post small notes with the headline: "I learned that ..."`
				},
				text: {
					da: `<b>Formål</b>
						<br />At samle små læringer, så I kan lære af hinanden og blive bedre sammen.
						<br /><br /><b>Hvad</b>
						<br />Sæt en opslagstavle op med post-its eller kort, hvor man kan skrive: 'Jeg lærte at…' Det kan være fejl, forbedringer eller små opdagelser. Tavlen kan tømmes eller læses op én gang om ugen. Det kan også gøres digitalt et sted i kommunikere med hinanden.
						<br /><br /><b>Hvornår</b>
						<br />Løbende – og gennemgå eventuelt én gang om ugen eller måneden.`,
					en: `<b>Purpose</b>
						<br />To collect experience so you can learn from each other and get better together. 
						<br /><br /><b>What</b>
						<br />Make a pinboard where you can post notes saying ""I learned that ..."" It can be mistakes, improvements, or small discoveries. Empty the board or read the notes once a week. You can also do it digitally if you have a place for it. 
						<br /><br /><b>When</b>
						<br />On a daily basis - but sum up once a week or once a month.`
				}
			},
			{
				id: 3,
				title: {
					da: `Vend fejlen om`,
					en: `Flip The Mistake`
				},
				shortText: {
					da: `Når der sker en fejl, øver vi os i at spørge: "Hvad kan vi lære af det her?" og "Kan vi gøre noget, så det ikke sker igen?"`,
					en: `When a mistake has been made, we practice asking: "What can we learn from this?" and "what can we do to keep it from happening again?"`
				},
				text: {
					da: `<b>Formål</b>
						<br />At gøre fejl til noget I lærer af, i stedet for at det kan blive noget, man skammer sig over.
						<br /><br /><b>Hvad</b>
						<br />Når der sker en fejl, sørger vi for, at vi tager fat i fejlen samme dag og besvare to spørgsmål: 1) Hvad kan vi lære af det her? 2) Hvad kan vi gøre, så det ikke sker igen? Tal om det roligt og nysgerrigt – ikke for at finde skyld.
						<br /><br /><b>Hvornår</b>
						<br />Samme dag som fejlen sker, men sørg for at der er ro til at tale om fejlen.`,
					en: `<b>Purpose</b>
						<br />To turn mistakes into something you learn from, instead of being something you are ashamed of. 
						<br /><br /><b>What</b>
						<br />When a mistake is made, we make sure to talk about it the very same day and ask two questions: 1) What can we learn from this? 2) What can we do so that it don't happen again?
						<br />Talk about it in a calm and curious manner - it's not about assigning blame. 
						<br /><br /><b>When</b>
						<br />The same day as the mistake has been made. But make sure you have time to talk about it.`
				}
			},
		]
	}
];



export {
	themesData
};